export const SCENSUM_WEBSITE_HEADER_HEIGHT = "70px";
export const BFC_PROGRESS_BAR_HEIGHT_MOBILE = "35px";

export const BFC_SPA_Uterum = "BFC_SPA_Uterum";
